The partner's unique identifier for the position. This will be null for job ads that were not posted via the syncPosition flow.

This identifier is used to track the position across sync operations.
